/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ThemeOptions } from '@mui/material/styles';

declare module '@mui/material/styles' {
	interface PaletteOptions {
		goldHighlight?: { light: string; main: string; dark: string };
	}

	interface Palette {
		goldHighlight: { light: string; main: string; dark: string };
	}
}

export const palette: ThemeOptions = {
	palette: {
		white: '#ffffff',
		foreground: '#ffffff',
		backgroundGray: '#eeeeee',
		overlay: 'rgba(238, 238, 238, 0.6)',
		primary: {
			light: '#fd8331',
			main: '#f96302',
			dark: '#c14c00',
		},
		secondary: {
			light: '#5796BA',
			main: '#3E7697',
			dark: '#325F7A',
		},
		text: {
			main: '#43484d',
			primary: '#43484d',
			secondary: '#5e6977',
			disabled: '#b5beca',
			highlight: '#00A950',
			alert: '#c10c0d',
			expandedMenu: '#ffffff',
		},
		base: {
			main: '#43484d',
			contrastText: '#ffffff',
		},
		action: {
			hover: '#f0f4f7',
			disabled: '#cccccc',
			disabledBackground: '#ddcfcf',
		},
		background: {
			main: '#fdfdfc',
			default: '#EEEEEE',
			paper: '#ffffff',
			transparency: 'cc', // used to combine hex colors with transparency (00-ff), e.g., #ffffffcc
			contrastText: '#43484d',
			selectedStore: '#f4f4f4',
		},
		divider: 'rgba(0, 0, 0, 0.12)',
		border: {
			dark: '#4c5256',
			alert: '#c10c0d',
			footer: '#888',
		},
		textField: {
			border: '#660b13',
			borderHovered: '#3a060b',
			background: '#fdfdfd',
			disabledBackground: '#ddcfcf',
		},
		button: {
			primary: '#2c0408',
			primaryHover: '#580911',
			secondary: '#ffffff',
			secondaryHover: '#fff4f4',
			contrastText: '#fdfdfd',
			disabled: '#ddcfcf',
			disabledText: '#a1a5ab',
		},
		success: {
			light: '#baf0d4',
			main: '#00a950',
			dark: '#088944',
		},
		error: {
			light: '#ffdad4',
			main: '#db1825',
			dark: '#af0d18',
		},
		warning: {
			light: '#fff2c9',
			main: '#a1803c',
			dark: '#80652f',
		},
		grey: {
			'50': '#eeeeee', // Light Gray
			'100': '#cccccc', // Gray
			'200': '#999999', // Medium Gray
			'300': '#777777', // Dark Gray
			'400': '#55565a', // PRO Shade
			'500': '#333333', // Black
		},
		inherit: {
			main: 'inherit',
			dark: 'inherit',
			light: 'inherit',
			contrastText: 'inherit',
		},
		productTagColor: {
			'tag_pdp-hs': '#E02631',
			'tag_pdp-bf': '#E00008',
			'tag_pdp-cd': '#333333',
			'tag_pdp-ex': '#3E7697',
		},
		alert: {
			main: '#A1803C',
			light: '#FFF2C9',
		},
		goldHighlight: {
			light: '#FCEAB6',
			main: '#FCD561',
			dark: '#582201',
		},
	},
} as ThemeOptions;
